<!-- 学校-学生考勤统计 -->
<template>
  <div>
    <div class="index" v-show="!detail.show">
      <div class="title">
        <div class="span1">
          <span>{{$route.name}}</span>
        </div>
      </div>

      <header>
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>班级出勤率前五名</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>班级出勤率后五名</span>
          </div>
          <div id="echarts-box2"></div>
        </div>
      </header>

      <div>
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="">
            <el-select
              v-model="queryParams.semester"
              clearable
              placeholder="选择学年学期"
              class="label"
            >
              <el-option
                v-for="item in semesterList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="queryParams.campus"
              clearable
              placeholder="选择校区"
              class="label"
            >
              <el-option
                v-for="item in campusList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="queryParams.grade"
              clearable
              placeholder="选择年级"
              class="label"
            >
              <el-option
                v-for="item in gradeList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="queryParams.class"
              clearable
              placeholder="选择班级"
              class="label"
            >
              <el-option
                v-for="item in classList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="queryParams.name"
              placeholder="请输入学生姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryParams.date"
              :picker-options="pickerOptions"
              style="width:275px"
              type="week"
              :format="queryParams.startDate + '~' + queryParams.endDate + '第 WW 周'"
              placeholder="选择周"
              @change="customTimeSure"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>

        <!-- 校内教师 -->
        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="className" label="班级" align="center">
            </el-table-column>
            <el-table-column
              prop="classStudentNum"
              label="学生总数"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="signNum" label="参与学生数" align="center">
            </el-table-column>
            <el-table-column
              prop="needAttendanceNum"
              label="应出勤人次"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="lateNum" label="迟到人次" align="center">
            </el-table-column>
            <el-table-column prop="leaveNum" label="请假人次" align="center">
            </el-table-column>
            <el-table-column
              prop="attendanceNum"
              label="实际出勤人次"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="attendanceRate"
              label="出勤率"
              align="center"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              width="200"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Detail
      :info="detail.info"
      v-show="detail.show"
      @to-index="toIndex"
    ></Detail>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import dayjs from "dayjs";
import * as echarts from "echarts";
export default {
  components: {
    Detail: () => import("./detail.vue"),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        semester: "",
        campus: "",
        grade: "",
        class: "",
        name: "",
        date: "",
        startDate:'',
        endDate:'',
      },
      campusList: [
        // {id:'campus1',label:'驻马店实验小学主校区'},
      ],
      semesterList: [
        {id:'xq1',label:'2021~2022年度下学期'},
				{id:'xq2',label:'2021~2022年度上学期'},
				{id:'xq3',label:'2020~2021年度下学期'},
				{id:'xq4',label:'2020~2021年度上学期'},
				{id:'xq5',label:'2019~2020年度下学期'},
				{id:'xq6',label:'2019~2020年度上学期'},
      ],
      gradeList: [
        {id:'g1',label:'一年级'},
				{id:'g2',label:'二年级'},
				{id:'g3',label:'三年级'},
				{id:'g4',label:'四年级'},
				{id:'g5',label:'五年级'},
				{id:'g6',label:'六年级'},
      ],
      classList: [
        {id:'bj1',label:'1班'},
				{id:'bj2',label:'2班'},
				{id:'bj3',label:'3班'},
				{id:'bj4',label:'4班'},
				{id:'bj5',label:'5班'},
				{id:'bj6',label:'6班'},
      ],
      tableData: [
        {className:'一年级1班',classStudentNum:'59',signNum:'38',needAttendanceNum:'45',lateNum:'8',leaveNum:'2',attendanceNum:'40',attendanceRate:'95.22%',},
        {className:'一年级2班',classStudentNum:'59',signNum:'38',needAttendanceNum:'45',lateNum:'8',leaveNum:'2',attendanceNum:'45',attendanceRate:'91.22%',},
        {className:'一年级3班',classStudentNum:'59',signNum:'38',needAttendanceNum:'43',lateNum:'8',leaveNum:'2',attendanceNum:'46',attendanceRate:'92.22%',},
        {className:'一年级4班',classStudentNum:'59',signNum:'38',needAttendanceNum:'42',lateNum:'8',leaveNum:'2',attendanceNum:'41',attendanceRate:'85.22%',},
        {className:'一年级5班',classStudentNum:'59',signNum:'38',needAttendanceNum:'41',lateNum:'8',leaveNum:'2',attendanceNum:'40',attendanceRate:'90.22%',},
        {className:'二年级1班',classStudentNum:'59',signNum:'38',needAttendanceNum:'42',lateNum:'8',leaveNum:'2',attendanceNum:'42',attendanceRate:'97.22%',},
        {className:'二年级2班',classStudentNum:'59',signNum:'38',needAttendanceNum:'42',lateNum:'8',leaveNum:'2',attendanceNum:'40',attendanceRate:'96.22%',},
      ],
      detail: {
        info: {},
        show: false,
      },
      school_info: JSON.parse(sessionStorage.getItem("classList")),
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  watch: {
    // "queryParams.campus": function (n, o) {
    //   this.queryParams.grade = "";
    //   this.queryParams.class = "";
    //   this.gradeList = [];
    //   this.classList = [];
    //   this.gradeList =
    //     this.campusList.filter((v) => v.id === n)[0]?.children || [];
    // },
    // "queryParams.grade": function (n, o) {
    //   this.queryParams.class = "";
    //   this.classList = [];
    //   this.classList =
    //     this.gradeList.filter((v) => v.id === n)[0]?.children || [];
    // },
  },
  created() {
    this.campusList = this.school_info?.slice() || [];
  },
  methods: {
    async getDataList() {
      let start = "",
        end = "";
      if (this.queryParams.date) {
        start = this.queryParams.startDate;
        end = this.queryParams.endDate;
      }
      let params = {
        schoolYearSemester: this.queryParams.semester,
        startDate: start,
        endDate: end,
        campusId:this.queryParams.campus,
        gradeId: this.queryParams.grade,
        classId: this.queryParams.class,
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        page: this.pageNum,
        limit: this.pageSize,
      };
      // let res = await api.classAttendanceStatistics(params);
      // if (res.code === "0") {
      //   this.tableData = res.data.list;
      //   this.totalPage = res.data.total || 0;
      // }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toDetail(item) {
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    // 自定义时间过滤
    customTimeSure() {
      let that = this.queryParams;
      if (that.date) {
        that.startDate = dayjs(that.date)
          .startOf("week")
          .format("YYYY-MM-DD");
        that.endDate = dayjs(that.date)
          .endOf("week")
          .format("YYYY-MM-DD");
      }
    },
    init(){
      let vm = this;
      this.$nextTick(() => {
        // 柱状图
        let chartDom1 = document.getElementById('echarts-box1');
        let myChart1 = echarts.init(chartDom1);
        let option1 = {

          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['一年级\n1班', '一年级\n2班', '一年级\n3班', '一年级\n4班', '一年级\n5班'],
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [88, 80, 77, 76, 70],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: '#5BB0FF' },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                  label: {
                    formatter: "{c}%",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
                
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart1.setOption(option1);

        // 柱状图
        let chartDom2 = document.getElementById('echarts-box2');
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['一年级\n1班', '一年级\n2班', '一年级\n3班', '一年级\n4班', '一年级\n5班'],
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [64, 63, 60, 59, 42],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: '#51D6A6' },
                  ]),
                  label: {
                    formatter: "{c}%",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart2.setOption(option2);
      });
    },
  },
  mounted() {
    if(this.semesterArr && this.semesterArr.length>0){
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "第" + v.semester + "学期",
        id: v.schoolYear + "_" + v.semester,
      }));
    }
    this.getDataList();
    this.init();
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }

  header{
    width: 100%;
    height: 350px;
    display: flex;
    .header-item{
      width: 50%;
      .header-item-title{
        font-size: 18px;
        color: #333;
        display: flex;
        align-items: center;
        .circle{
          width: 8px;
          height: 8px;
          display: inline-block;
          background: #4991e1;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
      .header-item-text{
        font-size: 14px;
        color: #666;
        padding-left: 20px;
        margin-top: 5px;
      }
    }
    #echarts-box1, #echarts-box2{
      width:90%;
      height:280px;
    }
  }
}
</style>
